import { useContext } from "react";
import { ACTIONS } from "../../contexts/sections/actions";
import { SectionContext } from "../../contexts/sections";

const useSection = () => {
  const { state, dispatch } = useContext(SectionContext);

  const { currentSection, visited } = state;

  const setSection = (sectionName, sectionElement) => {
    dispatch({
      type: ACTIONS.SET_CURRENT_SECTION,
      value: { name: sectionName, element: sectionElement },
    });
  };

  return { currentSection, visited, setSection };
};

export default useSection;
